import { VOMelody, VOMelodyPairItem, VOMelodyPart } from "../model/DataStructure.js";
import { MelodyContext } from "./MelodyContext.js";
import { StateMachine } from "./StateMachine.js";

export enum MelodyControlStates {
    SELECT_INSTRUMENT = "SELECT_INSTRUMENT",

    SELECT_MELODY = "SELECT_MELODY",

    FOREPLAY_FULL_INTRO = "FOREPLAY_FULL_INTRO",
    FOREPLAY_FULL = "FOREPLAY_FULL",

    FOREPLAY_PART_INTRO = "FOREPLAY_PART_INTRO",
    FOREPLAY_PART = "FOREPLAY_PART",
    FOREPLAY_PART_OUTRO = "FOREPLAY_PART_OUTRO",

    AFTERPIECE = "AFTERPIECE",
    AFTERPIECE_WRONG = "AFTERPIECE_WRONG",

    FINISHED_PART = "FINISHED_PART",
    FINISHED_COMPLETE = "FINISHED_COMPLETE",
}

export class MelodyControl extends StateMachine<MelodyControlStates, MelodyContext>{

    private _part: VOMelodyPart = null;
    private _melody: VOMelody = null;
    private _userNoteCounter = 0;

    constructor() {

        super();

        /**
         * Select Instrument
         */
        this.on({
            state: MelodyControlStates.SELECT_INSTRUMENT,
            enter: (ctx, env) => {
                ctx.nav.visible = false;
                // ctx.app.setItem(null);
                ctx.header.collapsed = true;
                ctx.instrumentSelector.visible = true;

                env.disposables.push(
                    ctx.instrumentSelector.onSelect.add((item) => {
                        ctx.melodySelector.item = item;
                        ctx.header.title = item?.name || "";
                        env.machine.state = MelodyControlStates.SELECT_MELODY;
                    })
                );
            },
            exit: (ctx) => {
                ctx.nav.visible = true;
                ctx.header.collapsed = false;
                ctx.instrumentSelector.visible = false;
            }
        });

        this.on({
            state: [
                MelodyControlStates.FOREPLAY_FULL_INTRO,
                MelodyControlStates.FOREPLAY_FULL,

                MelodyControlStates.FOREPLAY_PART_INTRO,
                MelodyControlStates.FOREPLAY_PART,
                MelodyControlStates.FOREPLAY_PART_OUTRO,

                MelodyControlStates.AFTERPIECE,
                MelodyControlStates.AFTERPIECE_WRONG,
                MelodyControlStates.FINISHED_COMPLETE,
                MelodyControlStates.FINISHED_PART
            ],
            enter: (ctx, env) => {
                ctx.instrument.visible = true;
                ctx.nav.help.visible = true;
                ctx.nav.reset.visible = true;

                env.disposables.push(
                    ctx.instrumentHeader.onRequestMelody.add(() => {
                        if (ctx.instrument?.visible) {
                            env.machine.state = MelodyControlStates.SELECT_MELODY;
                        }
                    }),

                    ctx.nav.reset.onClick.add(() => {
                        if (ctx.instrument?.visible) {
                            if (env.machine.state === MelodyControlStates.FOREPLAY_FULL_INTRO) {
                                env.machine.state = null;
                            }
                            env.machine.state = MelodyControlStates.FOREPLAY_FULL_INTRO;
                        }
                    }),

                    ctx.nav.help.onClick.add(() => {
                        ctx.help.visible = true;
                    })
                );
            },
            exit: (ctx) => {
                ctx.instrument.visible = false;
                ctx.nav.help.visible = false;
                ctx.nav.reset.visible = false;
            }
        });

        /**
         * Select Melody
         */
        this.on({
            state: MelodyControlStates.SELECT_MELODY,
            enter: (ctx, env) => {
                ctx.melodySelector.melody = null;
                ctx.melodySelector.visible = true;

                env.disposables.push(
                    ctx.melodySelector.onStart.add((m: VOMelodyPairItem, level) => {
                        this._melody = m.melody;
                        ctx.instrument.item = m;
                        ctx.melodySelector.melody = null;
                        ctx.instrumentHeader.level = level;
                        ctx.instrumentHeader.title = m.melody.name;
                        ctx.instrumentHeader.subtitle = m.melody.subtitle;
                        ctx.player.notes = m.melody.notes;
                        ctx.progress.parts = m.melody.parts;
                        env.machine.state = MelodyControlStates.FOREPLAY_FULL_INTRO;
                    })
                );
            },
            exit: (ctx) => {
                ctx.melodySelector.visible = false;
            }
        });

        /**
        * Foreplay Full Counter
        */
        this.on({
            state: MelodyControlStates.FOREPLAY_FULL_INTRO,
            enter: (ctx, env) => {

                ctx.instrument.buttonA.visible = true;
                ctx.instrument.buttonA.label = ctx.labels.text("melody.melody_instrument.foreplay.skip");

                ctx.instrument.title = ctx.labels.text("melody.melody_instrument.foreplay.full.title");
                ctx.instrument.subtitle = ctx.labels.text("melody.melody_instrument.foreplay.full.subtitle");
                ctx.visual.visible = true;
                env.disposables.push(
                    ctx.counter.onComplete.add(() => {
                        env.machine.state = MelodyControlStates.FOREPLAY_FULL;
                    }),
                    ctx.instrument.buttonA.onClick.add(() => {
                        this._part = this._melody.parts[0];
                        this._userNoteCounter = 0;
                        env.machine.state = MelodyControlStates.FOREPLAY_PART_INTRO;
                    })
                );
                ctx.counter.start();
            },
            exit: (ctx) => {
                ctx.instrument.buttonA.visible = false;
                ctx.instrument.title = "";
                ctx.instrument.subtitle = "";
                ctx.counter.stop();
                ctx.visual.visible = false;
            }
        });

        /**
        * Foreplay Full
        */
        this.on({
            state: MelodyControlStates.FOREPLAY_FULL,
            enter: (ctx, env) => {

                this._part = this._melody.parts[0];
                this._userNoteCounter = 0;


                ctx.instrument.buttonA.visible = true;
                ctx.instrument.buttonA.label = ctx.labels.text("melody.melody_instrument.foreplay.skip");

                ctx.progress.setCurly(this._melody.parts.length);
                // ctx.progress.setPoints(0, this._melody.parts.length);

                ctx.instrument.title = ctx.labels.text("melody.melody_instrument.foreplay.full.title");
                ctx.instrument.subtitle = ctx.labels.text("melody.melody_instrument.foreplay.full.subtitle");
                ctx.progress.visible = true;
                ctx.player.time = 0;
                ctx.player.play();
                ctx.visual.visible = true;

                // ctx.progress.setCurly(this._melody.parts.length);

                env.disposables.push(
                    ctx.player.onNote.add((note) => {
                        ctx.progress.setProgress(note.note.index + 1);
                    }),
                    ctx.player.onComplete.add(() => {
                        env.machine.state = MelodyControlStates.FOREPLAY_PART_INTRO;
                    }),
                    ctx.instrument.buttonA.onClick.add(() => {
                        env.machine.state = MelodyControlStates.FOREPLAY_PART_INTRO;
                    })
                );
            },
            exit: (ctx) => {
                ctx.progress.setCurly();
                ctx.progress.setPoints();
                ctx.instrument.buttonA.visible = false;
                ctx.instrument.title = "";
                ctx.instrument.subtitle = "";
                ctx.progress.visible = false;
                ctx.player.pause();
                ctx.visual.visible = false;
            }
        });


        /**
         * + Foreplay Part Intro 
         * + Foreplay Part
         * + Foreplay Part Outro
         */
        this.on({
            state: [
                MelodyControlStates.FOREPLAY_PART_INTRO,
                MelodyControlStates.FOREPLAY_PART,
                MelodyControlStates.FOREPLAY_PART_OUTRO

            ],
            enter: (ctx, env) => {
                ctx.visual.visible = true;

                ctx.instrument.title = ctx.labels.text({
                    key: "melody.melody_instrument.foreplay.generic.title",
                    params: {
                        part: this._part.index + 1
                    }
                });

                ctx.instrument.buttonA.visible = true;
                ctx.instrument.buttonA.label = ctx.labels.text("melody.melody_instrument.foreplay.button.repeat");

                ctx.instrument.buttonB.visible = true;
                ctx.instrument.buttonB.label = ctx.labels.text("melody.melody_instrument.foreplay.button.next");

                ctx.instrument.subtitle = ctx.labels.text("melody.melody_instrument.foreplay.generic.subtitle");
                ctx.instrument.info = ctx.labels.text("melody.melody_instrument.foreplay.generic.info");

                env.disposables.push(
                    ctx.instrument.buttonA.onClick.add(() => {
                        env.machine.stateForce = MelodyControlStates.FOREPLAY_PART_INTRO;
                    }),

                    ctx.instrument.buttonB.onClick.add(() => {
                        env.machine.state = MelodyControlStates.AFTERPIECE;
                    })
                );
            },
            exit: (ctx) => {
                ctx.instrument.buttonA.visible = false;
                ctx.instrument.buttonB.visible = false;
                ctx.instrument.title = "";
                ctx.instrument.subtitle = "";
                ctx.instrument.info = "";
                ctx.visual.visible = false;
            }
        });


        /**
         * Foreplay Part Counter
         */
        this.on({
            state: MelodyControlStates.FOREPLAY_PART_INTRO,
            enter: (ctx, env) => {
                env.disposables.push(
                    ctx.counter.onComplete.add(() => {
                        env.machine.state = MelodyControlStates.FOREPLAY_PART;
                    })
                );
                ctx.counter.start();
            },
            exit: (ctx) => {
                ctx.counter.stop();
            }
        });

        /**
         * Foreplay Part
         */
        this.on({
            state: MelodyControlStates.FOREPLAY_PART,
            enter: (ctx, env) => {

                ctx.progress.visible = true;
                ctx.player.time = 0;
                ctx.player.play();
                ctx.progress.setCurly(this._part.index + 1);
                // ctx.progress.setPoints(this._part.index);

                env.disposables.push(
                    ctx.player.onNote.add((note) => {
                        ctx.progress.setProgress(note.note.index + 1);
                        if (note.note.index >= this._part.countTotal - 1) {
                            env.machine.state = MelodyControlStates.FOREPLAY_PART_OUTRO;
                        }
                    })
                );
            },
            exit: (ctx) => {
                ctx.progress.setCurly();
                ctx.progress.setPoints();
                ctx.progress.visible = false;
                ctx.player.pause();
            }
        });

        /**
         * Foreplay Part Outro
         */
        this.on({
            state: MelodyControlStates.FOREPLAY_PART_OUTRO,
            enter: (ctx, env) => {
                ctx.instrument.buttonB.play(6);

                env.disposables.push(
                    ctx.instrument.buttonB.onFilled.add(() => {
                        env.machine.state = MelodyControlStates.AFTERPIECE;
                    })
                );
            },
            exit: (ctx) => {
                ctx.instrument.buttonB.stop();
            }
        });

        /**
         * Afterpiece
         */
        this.on({
            state: MelodyControlStates.AFTERPIECE,
            enter: (ctx, env) => {


                ctx.instrument.buttonA.visible = true;
                ctx.instrument.buttonA.label = ctx.labels.text("melody.melody_instrument.afterpiece.tip");

                ctx.instrument.title = ctx.labels.text({
                    key: "melody.melody_instrument.afterpiece.title",
                    params: {
                        part: this._part.index + 1,
                        total: this._melody.parts.length,
                        range: (this._part.index + 1) === 1 ? "1" : "1 bis " + (this._part.index + 1)
                    }
                });

                ctx.instrument.subtitle = ctx.labels.text("melody.melody_instrument.afterpiece.subtitle");
                ctx.instrument.info = ctx.labels.text("melody.melody_instrument.afterpiece.info");

                ctx.progress.visible = true;
                ctx.progress.setProgress(0);
                ctx.progress.setCurly(this._part.index + 1);
                // ctx.progress.setPoints(this._part.index);

                ctx.visual.visible = true;
                ctx.visual.clickable = true;

                this._userNoteCounter = 0;

                env.disposables.push(
                    ctx.visual.onAttack.add((area) => {
                        this._userNoteCounter++;

                        const expectedNote = this._melody.notes[this._userNoteCounter - 1];
                        const isCorrect = ctx.visual.match(expectedNote, area);

                        if (isCorrect) {
                            ctx.progress.setProgress(this._userNoteCounter);
                            if (this._userNoteCounter >= this._part.countTotal) {

                                ctx.visual.clickable = false;

                                env.disposables.push(
                                    this.setTimeout(() => {
                                        //Next part
                                        let index = this._melody.parts.indexOf(this._part);
                                        if (index < this._melody.parts.length - 1) {
                                            this._part = this._melody.parts[index + 1];

                                            env.machine.state = MelodyControlStates.FINISHED_PART;
                                        } else {
                                            env.machine.state = MelodyControlStates.FINISHED_COMPLETE;
                                        }
                                    }, 500)
                                );


                            }
                        } else {
                            ctx.visual.correct.show(expectedNote);
                            ctx.visual.wrong.show({
                                name: area.note,
                                midi: area.midi
                            });
                            env.machine.state = MelodyControlStates.AFTERPIECE_WRONG;
                        }
                    }),
                    ctx.player.onNote.add((e) => {
                        ctx.progress.setProgress(e.note.index + 1);
                    }),
                    ctx.instrument.buttonA.onClick.add(() => {
                        ctx.visual.correct.show(this._melody.notes[this._userNoteCounter]);
                    })
                );
            },
            exit: (ctx) => {
                ctx.instrument.buttonA.visible = false;
                ctx.visual.visible = false;
                ctx.visual.clickable = false;
                ctx.instrument.title = "";
                ctx.instrument.subtitle = "";
                ctx.instrument.info = "";
                ctx.progress.visible = false;
                this._userNoteCounter = 0;
                ctx.progress.setCurly();
                ctx.progress.setPoints();
                ctx.progress.setProgress(0);
            }
        });

        /**
         * Afterpiece wrong
         */
        this.on({
            state: MelodyControlStates.AFTERPIECE_WRONG,
            enter: (ctx, env) => {

                ctx.instrument.title = ctx.labels.text({
                    key: "melody.melody_instrument.afterpiece.wrong.title",
                    params: {
                        part: this._part.index + 1,
                        total: this._melody.parts.length,
                        range: (this._part.index + 1) === 1 ? "1" : "1 bis " + (this._part.index + 1)
                    }
                });
                ctx.instrument.subtitle = ctx.labels.text("melody.melody_instrument.afterpiece.wrong.subtitle");

                ctx.visual.visible = true;

                env.disposables.push(
                    ctx.counter.onComplete.add(() => {
                        env.machine.state = MelodyControlStates.FOREPLAY_PART;
                    }),
                    this.setTimeout(() => {
                        ctx.counter.start();
                    }, 1500)
                );
            },
            exit: (ctx) => {
                ctx.instrument.title = "";
                ctx.instrument.subtitle = "";
                ctx.visual.visible = false;
            }
        });

        /**
         * Finished Part
         */
        this.on({
            state: MelodyControlStates.FINISHED_PART,
            enter: (ctx, env) => {
                ctx.confetti.boxed = false;
                ctx.confetti.title = ctx.labels.text("melody.melody_instrument.afterpiece.finished.part.title");
                ctx.confetti.subtitle = ctx.labels.text({
                    key: "melody.melody_instrument.afterpiece.finished.part.subtitle",
                    params: {
                        part: this._part.index,
                        next: this._part.index + 1
                    }
                });
                ctx.confetti.visible = true;

                ctx.visual.visible = true;

                env.disposables.push(
                    this.setTimeout(() => {
                        env.machine.state = MelodyControlStates.FOREPLAY_PART_INTRO;
                    }, 4000)
                );
            },
            exit: (ctx) => {
                ctx.visual.visible = false;
                ctx.confetti.visible = false;
            }
        });

        /**
         * Finished Complete
         */
        this.on({
            state: MelodyControlStates.FINISHED_COMPLETE,
            enter: (ctx, env) => {
                ctx.confetti.title = ctx.labels.text("melody.melody_instrument.afterpiece.finished.title");
                ctx.confetti.subtitle = ctx.labels.text("melody.melody_instrument.afterpiece.finished.subtitle");
                ctx.confetti.boxed = true;
                ctx.confetti.visible = true;

                env.disposables.push(
                    ctx.confetti.onClickClose.add(() => {
                        env.machine.state = MelodyControlStates.SELECT_INSTRUMENT;
                    }),
                    ctx.confetti.onClickMelody.add(() => {
                        env.machine.state = MelodyControlStates.SELECT_MELODY;
                    }),
                    ctx.confetti.onClickInstrument.add(() => {
                        env.machine.state = MelodyControlStates.SELECT_INSTRUMENT;
                    }),
                )
            },
            exit: (ctx) => {
                ctx.confetti.visible = false;
            }
        });

        this.onUpdateContext.add(
            (e) => {
                const ctx = e.ctx;
                const env = e.env;

                e.disposables.push(

                    ctx.nav.home.onClick.add(() => {
                        env.machine.state = MelodyControlStates.SELECT_INSTRUMENT;
                    })
                );
            });
    }

    private setTimeout(cb: () => any, time: number): { dispose(): void; } {
        let to = setTimeout(cb, time);
        return {
            dispose: () => {
                clearTimeout(to);
            }
        };
    }
}